// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorPage_wrapper__GINzq","container":"ErrorPage_container__oSZRL","customCol":"ErrorPage_customCol__NTzFV"};